module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "illu",
    attrs: {
      "id": "illu1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#illu",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('strong', [_vm._v("Section One")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.  Hitler and Hindenburg shake hands at ‘The Day of Potsdam’ on 21 March 1933.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.  A stormtrooper enforces the boycott of Jewish shops, 1 April 1933.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.  ‘Hyenas are never decent, therefore neither are the Jews. Jews, get out!’")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  A sign on the outskirts of a German village declaring that ‘Jews are our misfortune.’")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Jews made to clean pavements in Vienna on 13 March 1938.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  The mass arrest of Jewish men in Oldenburg, 9 November 1938.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  The Horovitz Synagogue on Frankfurt’s Bornestrasse in flames during the pogrom of 9–10 November 1938.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.  The aftermath of ‘Kristallnacht’ in Magdeburg.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu21"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.  Medical examination of Jewish refugee children in the Netherlands, autumn 1938.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.   Jewish refugee girls from Germany being inspected by a British policeman, autumn 1938.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.   Raymond-Raoul Lambert.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.   Norbert Troller.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.   Philip Mechanicus.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.   Ruth Maier.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.   Abraham Krouwer, Abraham Asscher and David Cohen.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.   Victor Klemperer.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.   Philipp Manes.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.   Hélène Berr.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.   Mary Berg.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.   Adam Czerniaków.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('strong', [_vm._v("Section Two")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.   The gate to the Riga ghetto, from outside the ghetto fence.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.   Jewish children in Lublin, photographed by a German soldier and labelled ‘Jewish types’, c. 1941.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.   & 24. Scenes from a market in the Warsaw ghetto, taken by a member of the Wehrmacht in the early 1940s.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.   A Lodz ghetto stamp, bearing a portrait of Chaim Rumkowski.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.   A workshop in the Lodz ghetto, c. 1941–42.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.   A group of Jewish Latvian women forced to undress shortly before being shot by German troops in Liepaja, 15 December 1941.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.   A Jewish woman being abused during the pogrom in German-occupied Lvov, 30 June to 3 July 1941.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.   Jewish women from Kishinev assembled under Romanian military guard.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.   Jews in the Kaunus ghetto are boarded onto trucks during a deportation action.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.   The commandant of Sachsenhausen concentration camp, near Berlin, is greeted with the ‘Heil Hitler’ salute as prisoners stand to attention at roll call.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.   Jewish prisoners at Drancy internment camp in Paris, 1942.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.   Members of the Ordedienst (Jewish Order Service) assist Jewish prisoners onto a deportation train in the Westerbork transit camp, c. 1942/43.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.   Hungarian Jews rescued from deportation by Raoul Wallenberg, 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.   A prison choir performing in a courtyard at Theresienstadt, c. 1943.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.   Jewish inmates of Theresienstadt, early 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('strong', [_vm._v("Section Three")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.   Aerial photograph of Auschwitz-Birkenau, taken by the USAAF in 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.   Hungarian women and children arriving at Auschwitz, May/June 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39.   An elderly Jewish man arriving at Auschwitz, May/June 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40.   A transport of Hungarian women arriving at Auschwitz, May/June 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41.   Victims being selected at Auschwitz, May/June 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42.   One of the barracks at Bergen-Belsen shortly after the camp’s liberation in April 1945.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43.   Female SS guards supervised by British soldiers burying victims of Bergen-Belsen concentration camp in a mass grave.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44.   Aerial shot of the approaches to Treblinka, c. 1943.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45.   Cover of the 1946 publication of Rudolf Reder’s testimony from Belzec, in Polish.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46.   Displaced Persons’ Camp at Potsdamer Chaussee in Berlin-Zehlendorf, c. 1946.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47.   Jewish detainees in a Cyprus internment camp hold a rally in support of immigration to Palestine, 1948.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/photos#img48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48.   The first train carrying Jews bound for Palestine pulls out of the station at Bergen-Hohne, c. 1947.")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('strong', [_c('em', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("1–10, 17, 22–28, 32, 34, 38–43, 46, 48:   courtesy of the Wiener Library, London")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("11:   Yad Vashem")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("12:   courtesy of the Leo Baeck Institute")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("13 and 15:   Collection Jewish Historical Museum, Amsterdam")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("14:   © Erling T. Hofmo/NTB scanpix")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("16:   © Aufbau-Verlag/ullstein bild via Getty Images")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("18:   Mémorial de la Shoah/Coll. Mariette Job")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("19:   United States Holocaust Memorial Museum, courtesy of Mary Berg")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("20:   Adam Czerniakow. / Forum / Bridgeman Images")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("21, 30 and 47:   United States Holocaust Memorial Museum")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("29:   sourced from the YIVO Institute")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("31:   © Paul Popper/Popperfoto/Getty Images")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("33:   United States Holocaust Memorial Museum, courtesy of Trudi Gidan")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("35:   © akg-images / Bildarchiv Pisarek")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("36:   Keystone-France\\Gamma-Rapho via Getty Images")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("37:   © Roger-Viollet/REX Shutterstock")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("44:   © Mondadori Portfolio via Getty Images")]), _vm._v(" "), _c('p', {
    staticClass: "illu2"
  }, [_vm._v("45:   © Jewish Historical Institute")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ca15422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/illu.vue
// module id = 69
// module chunks = 0